import script from "./assetsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./assetsCard.vue?vue&type=script&setup=true&lang=js"

import "./assetsCard.vue?vue&type=style&index=0&id=f181de8a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f181de8a"]])

export default __exports__